import { ParamParseKey, useMatch } from 'react-router-dom';

export function useDynamicParam<T extends string>(pattern: T, param: ParamParseKey<T>) {
  return useMatch(pattern)?.params[param] || '';
}
